import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["fixed", "fluid", "backgroundColor", "children", "as", "className", "style"];
import React from 'react';
import BackgroundImage from 'gatsby-background-image';
import helpersPropTypes from '../../prop-types/helpersPropTypes';

var BackdropImage = function BackdropImage(_ref) {
  var fixed = _ref.fixed,
      fluid = _ref.fluid,
      backgroundColor = _ref.backgroundColor,
      children = _ref.children,
      as = _ref.as,
      className = _ref.className,
      style = _ref.style,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement(BackgroundImage, Object.assign({
    fluid: fluid,
    fixed: fixed,
    backgroundColor: backgroundColor,
    Tag: as,
    className: className,
    style: style
  }, props), children);
};

BackdropImage.defaultProps = {
  fluid: undefined,
  fixed: undefined,
  backgroundColor: undefined,
  as: undefined,
  children: undefined,
  className: undefined,
  style: null
};
export default BackdropImage;